console.log('custom.js');
$(document).ready(function(){
    if($('.main').find('.banner-block').length !== 0) {
        $('.header').addClass('w-banner');
        $('.header').css('background-color', 'transparent');
        $('.main').css('margin-top', "-110px");
    } else {
        $('.header').css('background-color', '#3F3932');
    }


    //accordion
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");

        $(this).next().slideToggle();
    });
    }

    //menu
    $('li.menu-item:has(.sub-menu)').click(function() {
        $(this).toggleClass('open-submenu');
    });

    //blog cards
    $('.grid--content .post--details').hover(function() {
        $(this).siblings('.img-link').children('.img-wrapper').children('.overlay').css('margin-top', '0');
    }, function(){
        $(this).siblings('.img-link').children('.img-wrapper').children('.overlay').css('margin-top', '60%');
    });

    $('.post--item .img-wrapper').hover(function() {
        $(this).children('.overlay').css('margin-top', '0');
    }, function(){
        $(this).children('.overlay').css('margin-top', '60%');
    });

    //select options style
    $('#input_1_5').css('color','#C6C9CB');
    $('#input_1_5').change(function() {
        var current = $('#input_1_5').val();
        if (current != 'null') {
            $('#input_1_5').css('color','#6B6965');
        } else {
            $('#input_1_5').css('color','#C6C9CB');
        }
    }); 
});

$(document).scroll(function () {
    var $nav = $(".header");
    $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
});

